import { withFeatureBranch } from '../redux/flags';
import CommentModal from './CommentModal';
import CommentModalContainer from './CommentModal.container';
import CommentModalV2 from './CommentModalV2';
export default withFeatureBranch({
    comment_v2: CommentModalContainer(CommentModalV2),
})(CommentModalContainer(CommentModal));
//# sourceMappingURL=index.js.map